<template>
  <div class="xl:sticky xl:top-0 flex justify-center z-40">
    <div
      class="border-b border-gray-200 lg:border-slate-900 dark:border-slate-600 w-full"
    >
      <div
        class="max-w-7xl mx-auto fixed xl:sticky top-0 shadow xl:shadow-none flex-shrink-0 h-16 dark:bg-slate-900 flex w-full backdrop-blur flex-none z-50 bg-gray-50 supports-backdrop-blur:bg-white"
      >
        <button
          type="button"
          class="px-4 focus:outline-none xl:hidden"
          @click="hamburger_menu_toggle"
        >
          <span class="sr-only">Open sidebar</span>
          <!-- Heroicon name: outline/menu-alt-2 -->
          <svg
            class="h-6 w-6"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 6h16M4 12h16M4 18h7"
            />
          </svg>
        </button>

        <div class="flex-1 flex justify-between items-center px-4 xl:px-0">
          <div class="mx-4 xl:mx-6 font-bold">
            {{ name.role.role_name }}
            <span v-if="name.role.name != ''"> - {{ name.role.name }} </span>
          </div>
          <div class="mx-4 flex justify-end items-center xl:mx-6">
            <button
              type="button"
              class="text-gray-500 ml-8 dark:text-gray-400 hover:text-gray-600 hover:dark:text-gray-600 focus:outline-none rounded-lg text-sm"
              @click="theme_toggle"
            >
              <svg
                id="theme-toggle-dark-icon"
                class="hidden w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
                />
              </svg>
              <svg
                id="theme-toggle-light-icon"
                class="hidden w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                />
              </svg>
            </button>

            <!-- <button
                        type="button"
                        class="mx-4 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                        <span class="sr-only">View notifications</span>
                        <svg
                            class="h-6 w-6"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                            aria-hidden="true"
                        >
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
                            />
                        </svg>
                    </button> -->

            <button
              id="user-menu-item-2"
              class="block py-2 px-4 w-full text-right text-sm hover:bg-gray-100 hover:dark:bg-slate-700"
              role="menuitem"
              tabindex="-1"
              @click="logout"
            >
              <svg
                class="stroke-current text-slate-900 dark:text-slate-400"
                width="25"
                height="25"
                viewBox="0 0 25 25"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.73486 21.1035H5.73486C5.20443 21.1035 4.69572 20.8928 4.32065 20.5177C3.94558 20.1427 3.73486 19.6339 3.73486 19.1035V5.10352C3.73486 4.57308 3.94558 4.06437 4.32065 3.6893C4.69572 3.31423 5.20443 3.10352 5.73486 3.10352H9.73486"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.7349 17.1035L21.7349 12.1035L16.7349 7.10352"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M21.7349 12.1035H9.73486"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <!-- Profile dropdown -->
            <!-- <div v-click-outside="theme_menu" class="relative">
                        <div>
                            <button 
                                @click="theme_menu('in')"
                                
                                type="button"
                                class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                                id="user-menu-button"
                                aria-expanded="false"
                                aria-haspopup="true"
                            >
                                <span class="sr-only">Open user menu</span>
                                <img
                                    class="h-8 w-8 rounded-full"
                                    src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                                    alt=""
                                />
                            </button>
                        </div>

                        <div v-if="menu" class="bg-white  dark:bg-slate-800 text-slate-500 dark:text-slate-400 origin-top-right absolute left-0 mt-2 w-48 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden focus:outline-none"
                            role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
            

                            <router-link to="/profile" class="block py-2 px-4 text-sm hover:bg-gray-100 hover:dark:bg-slate-700 ">

                                ملفك الشخصي

                            </router-link>

                        

                            <button
                                @click="logout"
                                class="block py-2 px-4 w-full text-right text-sm hover:bg-gray-100 hover:dark:bg-slate-700 "
                                role="menuitem"
                                tabindex="-1"
                                id="user-menu-item-2"
                                >تسجيل الخروج</button
                            >
                        </div>
                    </div> -->
          </div>
        </div>
      </div>
    </div>

    <div
      v-show="hamburger_menu"
      class="fixed inset-0 top-16 flex z-40 xl:hidden"
      role="dialog"
      aria-modal="true"
    >
      <button
        class="fixed inset-0 bg-gray-600 bg-opacity-75"
        aria-hidden="true"
        @click="hamburger_menu_toggle"
      />

      <div
        class="z-50 h-auto pt-5 pb-4 overflow-y-auto w-full ml-0 max-w-xs dark:bg-slate-900 border-l border-gray-200 backdrop-blur lg:border-slate-900/10 dark:border-slate-50/[0.06] bg-slate-900 supports-backdrop-blur:bg-white/95 dark:bg-slate-900/75"
      >
        <div class="flex-shrink-0 flex items-center px-4">
          <img
            class="h-8 w-auto"
            src="https://tailwindui.com/img/logos/workflow-logo-indigo-500-mark-white-text.svg"
            alt="Workflow"
          >
        </div>

        <nav class="mt-5 flex-1 px-2 space-y-1">
          <!-- START   91A5F652-8428-43D4-8648-3CB3C906D471      إدارة التطعيمات     -->

          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            :to="{ name: 'dashboardAdministrationOfVaccinations' }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/dashboard')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6"
              :class="
                this.checkRoutePath.includes('/dashboard')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            لوحة التحكم
          </router-link>

          <!-- المسؤولين -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/administrators"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/administrators')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6"
              :class="
                this.checkRoutePath.includes('/administrators')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
            المسؤولين
          </router-link>

          <!-- الطلبات -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            :to="{
              name: 'administrationOfVaccinationsOrder',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class=" 
              this.checkRoutePath.includes('/order')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/order')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
            >
              <path
                fill-rule="evenodd"
                d="M58.177 80H8.346A7.155 7.155 0 0 1 .99 73.083V6.916A7.155 7.155 0 0 1 8.346 0h49.831a7.155 7.155 0 0 1 7.358 6.916V18.15a1.991 1.991 0 0 1-3.982 0V6.916A3.176 3.176 0 0 0 58.177 4H8.346a3.174 3.174 0 0 0-3.374 2.916v66.167A3.174 3.174 0 0 0 8.346 76h49.831a2 2 0 1 1 0 4zM37.6 44.149h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 1 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm35.363-40h-7.488a2 2 0 1 1 0-4h7.488a2 2 0 0 1-.004 4h.004zm-17.443 0h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm57.142 37.478c-.1 0-.352-.019-.449-.033-11.029-1.627-21.81-4.838-22.588-23.772h-8.443a2 2 0 0 1-1.567-3.234l14.958-19.151a1.988 1.988 0 0 1 3.135 0l14.956 19.151a2 2 0 0 1-1.567 3.234h-8.518c-.407 10.127 3.465 14.041 11.431 18.213a2.966 2.966 0 0 1-1.352 5.592h.004zM49.435 45.822h6.3a1.994 1.994 0 0 1 1.991 1.991c.061 14.4 5.633 18.774 13.6 20.765-6.156-4.357-9.345-10.038-8.439-20.922a1.992 1.992 0 0 1 1.983-1.834h6.3L60.3 31.912l-10.865 13.91z"
              />
            </svg>
            الطلبات
          </router-link>

          <!-- السلة -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            :to="{ name: 'cart' }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/cart')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6"
              :class="
                this.checkRoutePath.includes('/cart')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z"
              />
            </svg>

            السلة
          </router-link>

          <!-- أوامر الصرف -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            :to="{
              name: 'administrationOfVaccinationsOrderStateBetweenMedicalSupplies',
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/state-orders')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/state-orders')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
            >
              <path
                fill-rule="evenodd"
                d="M58.177 80H8.346A7.155 7.155 0 0 1 .99 73.083V6.916A7.155 7.155 0 0 1 8.346 0h49.831a7.155 7.155 0 0 1 7.358 6.916V18.15a1.991 1.991 0 0 1-3.982 0V6.916A3.176 3.176 0 0 0 58.177 4H8.346a3.174 3.174 0 0 0-3.374 2.916v66.167A3.174 3.174 0 0 0 8.346 76h49.831a2 2 0 1 1 0 4zM37.6 44.149h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 1 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm35.363-40h-7.488a2 2 0 1 1 0-4h7.488a2 2 0 0 1-.004 4h.004zm-17.443 0h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm57.142 37.478c-.1 0-.352-.019-.449-.033-11.029-1.627-21.81-4.838-22.588-23.772h-8.443a2 2 0 0 1-1.567-3.234l14.958-19.151a1.988 1.988 0 0 1 3.135 0l14.956 19.151a2 2 0 0 1-1.567 3.234h-8.518c-.407 10.127 3.465 14.041 11.431 18.213a2.966 2.966 0 0 1-1.352 5.592h.004zM49.435 45.822h6.3a1.994 1.994 0 0 1 1.991 1.991c.061 14.4 5.633 18.774 13.6 20.765-6.156-4.357-9.345-10.038-8.439-20.922a1.992 1.992 0 0 1 1.983-1.834h6.3L60.3 31.912l-10.865 13.91z"
              />
            </svg>
            أوامر الصرف
          </router-link>

          <!-- المسجلين  -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/citizens"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/citizens')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/citizens')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 50 50"
              viewBox="0 0 50 50"
            >
              <path
                d="M24.3141,5.9217c-1.1045,0-2,0.8955-2,2v1.0835c0,3.0571-2.331,5.5801-5.3088,5.8854h-6.6319c-2.9783-0.3052-5.3093-2.8283-5.3093-5.8854V7.9217c0-2.6419-4-2.6449-4,0v1.0835c0,4.4979,3.0131,8.3001,7.1251,9.5096v11.2928c-0.0042,0.0524-0.0157,0.1027-0.0157,0.1561v16c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h2.9585v15.0419c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h0.0573v-12.407c4.1119-1.2095,7.1249-5.0116,7.1249-9.5096V7.9217C26.3141,6.8173,25.4186,5.9217,24.3141,5.9217z"
              />
              <path
                d="M13.6893 12.9219c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4C8.4061 4.9219 8.3991 12.9219 13.6893 12.9219zM6.06 8.736v.27M4 17.366H2.26v-.5C1.8611 16.8992 1.3929 16.8715 1 16.736v4.72h6.19v-2.22C6.01 18.796 4.94 18.166 4 17.366zM47.52 17.366v-1.33h-1.18v-3.24H45.1v3.24h-1.17v-1.97h-2.51v1.97H40.3v-9.69h-.62v-2.81h-.96v-1.5h-2.7v1.5h-.96v2.81h-.61v11.02h-.92v-7.93H27.29c-.06 1.73-.54 3.39-1.37 4.85.22.16.36.43.36.75 0 .52-.4.94-.89.94-.18 0-.35-.05-.49-.15-1.22 1.51-2.83 2.71-4.71 3.41v2.22H49v-4.09H47.52zM28.2 15.976c-.51 0-.92-.42-.92-.94 0-.53.41-.94.92-.94.49 0 .89.41.89.94C29.09 15.556 28.69 15.976 28.2 15.976zM28.2 12.956c-.51 0-.92-.42-.92-.93 0-.54.41-.96.92-.96.49 0 .89.42.89.96C29.09 12.536 28.69 12.956 28.2 12.956zM30.98 15.976c-.5 0-.89-.42-.89-.94 0-.53.39-.94.89-.94s.92.41.92.94C31.9 15.556 31.48 15.976 30.98 15.976zM30.98 12.956c-.5 0-.89-.42-.89-.93 0-.54.39-.96.89-.96s.92.42.92.96C31.9 12.536 31.48 12.956 30.98 12.956zM36.34 16.576h-1.06v-8.12h1.06V16.576zM37.89 16.576h-1.03v-8.12h1.03V16.576zM39.46 16.576h-1.05v-8.12h1.05V16.576z"
              />
              <rect
                width="2.259"
                height="3.54"
                x="30.459"
                y="4.81"
              />
              <path d="M1.355,16.756" />
            </svg>
            المسجلين
          </router-link>


          <!-- الفئات العمرية -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/AgeCategories"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/AgeCategories')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current stroke-2"
              :class="
                this.checkRoutePath.includes('/AgeCategories')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 3"
              viewBox="0 0 64 64"
            >
              <path
                d="M51.707,1.293a1,1,0,0,0-1.414,0l-3,3a1,1,0,0,0,0,1.414L50.086,8.5,47,11.586,44.707,9.293a1,1,0,0,0-1.414,0l-29,29a1,1,0,0,0,0,1.414L16.086,41.5l-2.793,2.793a1,1,0,0,0,0,1.414L15.086,47.5,1.293,61.293l1.414,1.414L16.5,48.914l1.793,1.793a1,1,0,0,0,1.414,0L22.5,47.914l1.793,1.793a1,1,0,0,0,1.414,0L44.715,30.7A2.951,2.951,0,0,0,46,31v2H45a4,4,0,0,0-4,4V59a4,4,0,0,0,4,4H57a4,4,0,0,0,4-4V37a4,4,0,0,0-4-4H56V31a3,3,0,0,0,0-6V24a3,3,0,0,0-1.826-2.76l.533-.533a1,1,0,0,0,0-1.414L52.414,17,55.5,13.914l2.793,2.793a1,1,0,0,0,1.414,0l3-3a1,1,0,0,0,0-1.414ZM19,48.586,15.414,45,17.5,42.914,21.086,46.5Zm6-1L16.414,39l13-13H43.78A2.981,2.981,0,0,0,43,28a2.926,2.926,0,0,0,.081.666l-1.374-1.373-1.414,1.414L42.086,30.5,39,33.586l-3.293-3.293-1.414,1.414L37.586,35,34.5,38.086l-1.793-1.793-1.414,1.414L33.086,39.5,30,42.586l-3.293-3.293-1.414,1.414L28.586,44ZM59,55H48V40H59ZM55,35h2a2,2,0,0,1,2,2v1H47a1,1,0,0,0-1,1V56a1,1,0,0,0,1,1H59v2a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V37a2,2,0,0,1,2-2h2a1,1,0,0,0,1-1V31h6v3A1,1,0,0,0,55,35Zm2-7a1,1,0,0,1-1,1H46a1,1,0,0,1,0-2H56A1,1,0,0,1,57,28Zm-9-3V24a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v1Zm3.586-4H49a3,3,0,0,0-3,3H31.414L44,11.414,52.586,20ZM51,15.586,48.414,13,51.5,9.914,54.086,12.5Zm8-1L49.414,5,51,3.414,60.586,13Z"
              />
            </svg>

            الفئات العمرية
          </router-link>

          <!-- اللقاحات -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/vaccines"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/vaccines')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current stroke-2"
              :class="
                this.checkRoutePath.includes('/vaccines')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 3"
              viewBox="0 0 64 64"
            >
              <path
                d="M51.707,1.293a1,1,0,0,0-1.414,0l-3,3a1,1,0,0,0,0,1.414L50.086,8.5,47,11.586,44.707,9.293a1,1,0,0,0-1.414,0l-29,29a1,1,0,0,0,0,1.414L16.086,41.5l-2.793,2.793a1,1,0,0,0,0,1.414L15.086,47.5,1.293,61.293l1.414,1.414L16.5,48.914l1.793,1.793a1,1,0,0,0,1.414,0L22.5,47.914l1.793,1.793a1,1,0,0,0,1.414,0L44.715,30.7A2.951,2.951,0,0,0,46,31v2H45a4,4,0,0,0-4,4V59a4,4,0,0,0,4,4H57a4,4,0,0,0,4-4V37a4,4,0,0,0-4-4H56V31a3,3,0,0,0,0-6V24a3,3,0,0,0-1.826-2.76l.533-.533a1,1,0,0,0,0-1.414L52.414,17,55.5,13.914l2.793,2.793a1,1,0,0,0,1.414,0l3-3a1,1,0,0,0,0-1.414ZM19,48.586,15.414,45,17.5,42.914,21.086,46.5Zm6-1L16.414,39l13-13H43.78A2.981,2.981,0,0,0,43,28a2.926,2.926,0,0,0,.081.666l-1.374-1.373-1.414,1.414L42.086,30.5,39,33.586l-3.293-3.293-1.414,1.414L37.586,35,34.5,38.086l-1.793-1.793-1.414,1.414L33.086,39.5,30,42.586l-3.293-3.293-1.414,1.414L28.586,44ZM59,55H48V40H59ZM55,35h2a2,2,0,0,1,2,2v1H47a1,1,0,0,0-1,1V56a1,1,0,0,0,1,1H59v2a2,2,0,0,1-2,2H45a2,2,0,0,1-2-2V37a2,2,0,0,1,2-2h2a1,1,0,0,0,1-1V31h6v3A1,1,0,0,0,55,35Zm2-7a1,1,0,0,1-1,1H46a1,1,0,0,1,0-2H56A1,1,0,0,1,57,28Zm-9-3V24a1,1,0,0,1,1-1h4a1,1,0,0,1,1,1v1Zm3.586-4H49a3,3,0,0,0-3,3H31.414L44,11.414,52.586,20ZM51,15.586,48.414,13,51.5,9.914,54.086,12.5Zm8-1L49.414,5,51,3.414,60.586,13Z"
              />
            </svg>

            اللقاحات
          </router-link>


         

          <!-- الجنسيات -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/nationalities"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/nationalities')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6"
              :class="
                this.checkRoutePath.includes('/nationalities')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>

            الجنسيات
          </router-link>

          <!-- الامداد الطبي -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/medical-supplies"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/medical-supplies')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/medical-supplies')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              data-name="Layer 1"
              viewBox="0 0 64 64"
            >
              <path
                d="M54.6 42.23a4.49 4.49 0 0 1-2 3 4.33 4.33 0 0 1-3.41.66 3.62 3.62 0 0 1-2.77-3.6 4.55 4.55 0 0 1 4.48-4.46 4.17 4.17 0 0 1 .91.1 3.66 3.66 0 0 1 2.79 4.3Z"
              />
              <path
                d="M30.68 22.83A5.28 5.28 0 1 0 36 28.11a5.29 5.29 0 0 0-5.32-5.28Zm.71 6v3.11H30v-3.12h-3.14V27.4H30v-3.12h1.42v3.12h3.08v1.42Zm-.71-6A5.28 5.28 0 1 0 36 28.11a5.29 5.29 0 0 0-5.32-5.28Zm.71 6v3.11H30v-3.12h-3.14V27.4H30v-3.12h1.42v3.12h3.08v1.42Zm26.73 1.47-4.59-5a3.48 3.48 0 0 0-2.64-1.17h-5.71l.51-4.7A1.33 1.33 0 0 0 44.34 18H14a1.56 1.56 0 0 0-1.56 1.37l-.06.59-.19 1.76v.1h-3a.91.91 0 1 0 0 1.83H12l-.17 1.59v.11H6.54a.91.91 0 0 0 0 1.83h5.08l-.17 1.59v.1H8.84a.91.91 0 0 0 0 1.83h2.4l-.17 1.59v.1H5.79a.91.91 0 0 0 0 1.83h5.07L10 41.93h6v-.23a6.06 6.06 0 0 1 4.63-5.14 5 5 0 0 1 6.48 4.25c0 .36 0 .73.06 1.11h17.77a1.36 1.36 0 0 0 0-.17 6.19 6.19 0 0 1 5.33-5.34A5 5 0 0 1 56 40.5c.08.46.08.93.13 1.44h.65a1.64 1.64 0 0 0 1.66-1.54c.21-2.38.41-4.76.62-7.14a3.69 3.69 0 0 0-.94-2.96Zm-27.44 4.61a6.8 6.8 0 1 1 6.8-6.8 6.81 6.81 0 0 1-6.8 6.8Zm15.26-4.12c.1-1.19-.17-3.64.4-4.66s2.61-.52 3.76-.53a2.82 2.82 0 0 1 2.74 1.22l3.59 4Zm-15.26-8A5.28 5.28 0 1 0 36 28.11a5.29 5.29 0 0 0-5.32-5.28Zm3.82 6h-3.11v3.11H30v-3.08h-3.14V27.4H30v-3.12h1.42v3.12h3.08Z"
              />
              <path
                d="M25.66 41.57v.32A4.61 4.61 0 0 1 21.53 46a3.66 3.66 0 0 1-3-1 3.82 3.82 0 0 1-1.09-3v-.24a4.5 4.5 0 0 1 2.22-3.25 4.43 4.43 0 0 1 2.22-.62 4 4 0 0 1 .76.07 3.88 3.88 0 0 1 .73.22 3.64 3.64 0 0 1 2.29 3.39Z"
              />
            </svg>

            الامداد الطبي
          </router-link>

          <!-- البلديات -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/municipals"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/municipals')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current"
              :class="
                this.checkRoutePath.includes('/municipals')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 32 32"
            >
              <path
                d="M31 20.349H1a.5.5 0 0 1-.5-.5v-3.947a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211H5.96v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.697v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.632v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.697v-1.211a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.211h1.697v-1.211a.5.5 0 0 1 .5-.5H31a.5.5 0 0 1 .5.5v3.947a.5.5 0 0 1-.5.5zm-29.5-1h29v-2.947h-1.763v1.211a.5.5 0 0 1-.5.5H25.54a.5.5 0 0 1-.5-.5v-1.211h-1.763v1.211a.5.5 0 0 1-.5.5H20.08a.5.5 0 0 1-.5-.5v-1.211h-1.763v1.211a.5.5 0 0 1-.5.5h-2.632a.5.5 0 0 1-.5-.5v-1.211h-1.763v1.211a.5.5 0 0 1-.5.5H9.224a.5.5 0 0 1-.5-.5v-1.211H6.96v1.211a.5.5 0 0 1-.5.5H3.763a.5.5 0 0 1-.5-.5v-1.211H1.5v2.947z"
              />
              <path
                d="M29.487 31.533H2.513a.5.5 0 0 1-.5-.5V19.849a.5.5 0 0 1 .5-.5h26.974a.5.5 0 0 1 .5.5v11.185a.5.5 0 0 1-.5.499zm-26.474-1h25.974V20.349H3.013v10.184zm6.194-12.421a.5.5 0 0 1-.5-.5v-7.396H4.313v7.396a.5.5 0 0 1-1 0V9.717a.5.5 0 0 1 .5-.5h5.395a.5.5 0 0 1 .5.5v7.896a.5.5 0 0 1-.501.499z"
              />
              <path
                d="M22.76 16.401a.5.5 0 0 1-.5-.5v-5.685H9.707v5.685a.5.5 0 0 1-1 0V9.717a.5.5 0 0 1 .5-.5H22.76a.5.5 0 0 1 .5.5v6.185a.5.5 0 0 1-.5.499z"
              />
              <path
                d="M22.76 12.257H9.207a.5.5 0 0 1 0-1H22.76a.5.5 0 0 1 0 1z"
              />
              <path
                d="M28.155 18.112a.5.5 0 0 1-.5-.5v-7.396H23.26v7.396a.5.5 0 0 1-1 0V9.717a.5.5 0 0 1 .5-.5h5.395a.5.5 0 0 1 .5.5v7.896a.5.5 0 0 1-.5.499zm-8.208 13.421h-7.895a.5.5 0 0 1-.5-.5v-4.605c0-2.452 1.995-4.447 4.447-4.447s4.447 1.995 4.447 4.447v4.605a.497.497 0 0 1-.499.5zm-7.394-1h6.895v-4.105c0-1.9-1.546-3.447-3.447-3.447s-3.447 1.547-3.447 3.447v4.105zm-1.931-20.316H2.398a.5.5 0 0 1-.5-.5V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.21h1.697V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v3.947a.499.499 0 0 1-.499.5zm-7.724-1h7.224V6.27H8.358v1.21a.5.5 0 0 1-.5.5H5.161a.5.5 0 0 1-.5-.5V6.27H2.898v2.947z"
              />
              <path
                d="M29.569 10.217h-8.224a.5.5 0 0 1-.5-.5V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v1.21h1.698V5.77a.5.5 0 0 1 .5-.5h2.763a.5.5 0 0 1 .5.5v3.947a.5.5 0 0 1-.5.5zm-7.724-1h7.224V6.27h-1.763v1.21a.5.5 0 0 1-.5.5h-2.698a.5.5 0 0 1-.5-.5V6.27h-1.763v2.947zM15.967 7.98a.5.5 0 0 1-.5-.5V.967a.5.5 0 0 1 .5-.5h3.75a.501.501 0 0 1 .311.891l-3.562 2.837V7.48a.497.497 0 0 1-.499.5zm.5-6.513v1.449l1.82-1.449h-1.82z"
              />
              <path
                d="M18.138 10.217h-4.342a.5.5 0 0 1-.5-.5V7.645a.5.5 0 0 1 .5-.5h4.342a.5.5 0 0 1 .5.5v2.072a.5.5 0 0 1-.5.5zm-3.842-1h3.342V8.145h-3.342v1.072zM7.694 24.888H5.326a.5.5 0 0 1-.5-.5v-2.104a.5.5 0 0 1 .5-.5h2.368a.5.5 0 0 1 .5.5v2.104a.5.5 0 0 1-.5.5zm-1.868-1h1.368v-1.104H5.826v1.104zm20.816 1h-2.369a.5.5 0 0 1-.5-.5v-2.104a.5.5 0 0 1 .5-.5h2.369a.5.5 0 0 1 .5.5v2.104a.5.5 0 0 1-.5.5zm-1.869-1h1.369v-1.104h-1.369v1.104z"
              />
            </svg>

            البلديات
          </router-link>

          <!-- مراكز التطعيم -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/vaccination-centers"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/vaccination-centers')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current stroke-2"
              :class="
                this.checkRoutePath.includes('/vaccination-centers')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 48 48"
            >
              <mask
                id="a"
                fill="#fff"
              >
                <path d="M23 12L5 12L5 14L23 14V12Z" />
                <path
                  fill-rule="evenodd"
                  d="M23 16H6V37H5C4.44772 37 4 37.4477 4 38C4 38.5523 4.44772 39 5 39H43C43.5523 39 44 38.5523 44 38C44 37.4477 43.5523 37 43 37H42V16H39V18H40V37H37V25H29V37H8V18H23V16ZM35 37H31V27H35V37Z"
                  clip-rule="evenodd"
                />
                <path d="M39 14V12L43 12V14L39 14Z" />
                <path
                  fill-rule="evenodd"
                  d="M11 32V25H26V32L27 32V34L10 34V32H11ZM13 27H24V32H13V27Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M35 10H27C25.8954 10 25 10.8954 25 12V20C25 21.1046 25.8954 22 27 22H35C36.1046 22 37 21.1046 37 20V12C37 10.8954 36.1046 10 35 10Z"
                />
              </mask>
              <path
                fill="#333"
                d="M32 14V13H30V14H32ZM29 15H28V17H29V15ZM6 13V18H8V13H6ZM40 13V18H42V13H40ZM30 14V18H32V14H30ZM29 17L33 17V15L29 15V17ZM23 12H25V10L23 10V12ZM5 12L5 10L3 10L3 12L5 12ZM5 14L3 14L3 16H5L5 14ZM23 14V16H25V14H23ZM23 16H25V14H23V16ZM6 16V14H4V16H6ZM6 37V39H8V37H6ZM42 37H40V39H42V37ZM42 16H44V14H42V16ZM39 16V14H37V16H39ZM39 18H37V20H39V18ZM40 18H42V16H40V18ZM40 37V39H42V37H40ZM37 37H35V39H37V37ZM37 25H39V23H37V25ZM29 25V23H27V25H29ZM29 37V39H31V37H29ZM8 37H6V39H8V37ZM8 18V16H6V18H8ZM23 18V20H25V18H23ZM39 12V10L37 10V12H39ZM39 14H37V16H39V14ZM43 12H45V10L43 10V12ZM43 14V16L45 16V14H43ZM31 37H29V39H31V37ZM35 37V39H37V37H35ZM31 27V25H29V27H31ZM35 27H37V25H35V27ZM24 27H26V25H24V27ZM13 27V25H11V27H13ZM24 32V34H26V32H24ZM13 32H11V34H13V32ZM11 32V34H13V32H11ZM11 25V23H9V25H11ZM26 25H28V23H26V25ZM26 32H24V34L26 34L26 32ZM27 32H29V30L27 30L27 32ZM27 34V36H29V34H27ZM10 34H8V36H10V34ZM10 32V30H8V32H10ZM23 10L5 10L5 14L23 14V10ZM3 12L3 14L7 14V12L3 12ZM5 16L23 16V12L5 12L5 16ZM25 14V12H21V14H25ZM5 39H6V35H5V39ZM6 38C6 38.5523 5.55229 39 5 39V35C3.34315 35 2 36.3431 2 38H6ZM5 37C5.55229 37 6 37.4477 6 38H2C2 39.6569 3.34315 41 5 41V37ZM42 38C42 37.4477 42.4477 37 43 37V41C44.6569 41 46 39.6569 46 38H42ZM43 39C42.4477 39 42 38.5523 42 38H46C46 36.3431 44.6569 35 43 35V39ZM42 39H43V35H42V39ZM37 16V18H41V16H37ZM39 20H40V16H39V20ZM38 18V37H42V18H38ZM40 35H37V39H40V35ZM29 35H8V39H29V35ZM10 37V18H6V37H10ZM8 20H23V16H8V20ZM25 18V16H21V18H25ZM37 12V14H41V12H37ZM43 10L39 10V14L43 14V10ZM45 14V12H41V14H45ZM39 16L43 16V12L39 12V16ZM31 39H35V35H31V39ZM29 27V37H33V27H29ZM35 25H31V29H35V25ZM37 37V27H33V37H37ZM24 25H13V29H24V25ZM26 32V27H22V32H26ZM13 34H24V30H13V34ZM11 27V32H15V27H11ZM27 30L26 30L26 34L27 34L27 30ZM29 34V32H25V34H29ZM8 32V34H12V32H8ZM11 30H10V34H11V30ZM27 12H35V8H27V12ZM35 12V20H39V12H35ZM35 20H27V24H35V20ZM27 20V12H23V20H27ZM27 20H23C23 22.2091 24.7909 24 27 24V20ZM35 20V24C37.2091 24 39 22.2091 39 20H35ZM35 12H39C39 9.79086 37.2091 8 35 8V12ZM27 8C24.7909 8 23 9.79086 23 12H27V12V8ZM6 18H23V14H6V18ZM8 37V16H4V37H8ZM43 37H5V41H43V37ZM40 16V37H44V16H40ZM39 18H42V14H39V18ZM39 37V25H35V37H39ZM37 23H29V27H37V23ZM27 25V37H31V25H27ZM9 25V32H13V25H9ZM26 23H11V27H26V23ZM28 32V25H24V32H28ZM10 36L27 36V32L10 32V36Z"
                mask="url(#a)"
              />
            </svg>
            مراكز التطعيم
          </router-link>

          <!-- الإحصائيات -->
          <router-link
            v-if="
              role.id == 'f1291955-df5e-4fcc-bc63-1b16aa99b63b' ||
                role.id == '91a5f652-8428-43d4-8648-3cb3c906d471'
            "
            to="/ad1020/statistics"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/statistics')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current stroke-2"
              :class="
                this.checkRoutePath.includes('/statistics')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 48 48"
            >
              <mask
                id="a"
                fill="#fff"
              >
                <path d="M23 12L5 12L5 14L23 14V12Z" />
                <path
                  fill-rule="evenodd"
                  d="M23 16H6V37H5C4.44772 37 4 37.4477 4 38C4 38.5523 4.44772 39 5 39H43C43.5523 39 44 38.5523 44 38C44 37.4477 43.5523 37 43 37H42V16H39V18H40V37H37V25H29V37H8V18H23V16ZM35 37H31V27H35V37Z"
                  clip-rule="evenodd"
                />
                <path d="M39 14V12L43 12V14L39 14Z" />
                <path
                  fill-rule="evenodd"
                  d="M11 32V25H26V32L27 32V34L10 34V32H11ZM13 27H24V32H13V27Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M35 10H27C25.8954 10 25 10.8954 25 12V20C25 21.1046 25.8954 22 27 22H35C36.1046 22 37 21.1046 37 20V12C37 10.8954 36.1046 10 35 10Z"
                />
              </mask>
              <path
                fill="#333"
                d="M32 14V13H30V14H32ZM29 15H28V17H29V15ZM6 13V18H8V13H6ZM40 13V18H42V13H40ZM30 14V18H32V14H30ZM29 17L33 17V15L29 15V17ZM23 12H25V10L23 10V12ZM5 12L5 10L3 10L3 12L5 12ZM5 14L3 14L3 16H5L5 14ZM23 14V16H25V14H23ZM23 16H25V14H23V16ZM6 16V14H4V16H6ZM6 37V39H8V37H6ZM42 37H40V39H42V37ZM42 16H44V14H42V16ZM39 16V14H37V16H39ZM39 18H37V20H39V18ZM40 18H42V16H40V18ZM40 37V39H42V37H40ZM37 37H35V39H37V37ZM37 25H39V23H37V25ZM29 25V23H27V25H29ZM29 37V39H31V37H29ZM8 37H6V39H8V37ZM8 18V16H6V18H8ZM23 18V20H25V18H23ZM39 12V10L37 10V12H39ZM39 14H37V16H39V14ZM43 12H45V10L43 10V12ZM43 14V16L45 16V14H43ZM31 37H29V39H31V37ZM35 37V39H37V37H35ZM31 27V25H29V27H31ZM35 27H37V25H35V27ZM24 27H26V25H24V27ZM13 27V25H11V27H13ZM24 32V34H26V32H24ZM13 32H11V34H13V32ZM11 32V34H13V32H11ZM11 25V23H9V25H11ZM26 25H28V23H26V25ZM26 32H24V34L26 34L26 32ZM27 32H29V30L27 30L27 32ZM27 34V36H29V34H27ZM10 34H8V36H10V34ZM10 32V30H8V32H10ZM23 10L5 10L5 14L23 14V10ZM3 12L3 14L7 14V12L3 12ZM5 16L23 16V12L5 12L5 16ZM25 14V12H21V14H25ZM5 39H6V35H5V39ZM6 38C6 38.5523 5.55229 39 5 39V35C3.34315 35 2 36.3431 2 38H6ZM5 37C5.55229 37 6 37.4477 6 38H2C2 39.6569 3.34315 41 5 41V37ZM42 38C42 37.4477 42.4477 37 43 37V41C44.6569 41 46 39.6569 46 38H42ZM43 39C42.4477 39 42 38.5523 42 38H46C46 36.3431 44.6569 35 43 35V39ZM42 39H43V35H42V39ZM37 16V18H41V16H37ZM39 20H40V16H39V20ZM38 18V37H42V18H38ZM40 35H37V39H40V35ZM29 35H8V39H29V35ZM10 37V18H6V37H10ZM8 20H23V16H8V20ZM25 18V16H21V18H25ZM37 12V14H41V12H37ZM43 10L39 10V14L43 14V10ZM45 14V12H41V14H45ZM39 16L43 16V12L39 12V16ZM31 39H35V35H31V39ZM29 27V37H33V27H29ZM35 25H31V29H35V25ZM37 37V27H33V37H37ZM24 25H13V29H24V25ZM26 32V27H22V32H26ZM13 34H24V30H13V34ZM11 27V32H15V27H11ZM27 30L26 30L26 34L27 34L27 30ZM29 34V32H25V34H29ZM8 32V34H12V32H8ZM11 30H10V34H11V30ZM27 12H35V8H27V12ZM35 12V20H39V12H35ZM35 20H27V24H35V20ZM27 20V12H23V20H27ZM27 20H23C23 22.2091 24.7909 24 27 24V20ZM35 20V24C37.2091 24 39 22.2091 39 20H35ZM35 12H39C39 9.79086 37.2091 8 35 8V12ZM27 8C24.7909 8 23 9.79086 23 12H27V12V8ZM6 18H23V14H6V18ZM8 37V16H4V37H8ZM43 37H5V41H43V37ZM40 16V37H44V16H40ZM39 18H42V14H39V18ZM39 37V25H35V37H39ZM37 23H29V27H37V23ZM27 25V37H31V25H27ZM9 25V32H13V25H9ZM26 23H11V27H26V23ZM28 32V25H24V32H28ZM10 36L27 36V32L10 32V36Z"
                mask="url(#a)"
              />
            </svg>
            الإحصائيات
          </router-link>

          <!-- END إدارة التطعيمات      -->

          <!-- START 1C74F9E8-FABA-4051-BEBC-DB08ED11DBCC  إدارة البلدية      -->

          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{ name: 'dashboardMunicipalities' }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/dashboard')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6"
              :class="
                this.checkRoutePath.includes('/dashboard')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            لوحة التحكم
          </router-link>

          <!-- الإحصائيات -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            to="/m4050/statistics"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/statistics')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current stroke-2"
              :class="
                this.checkRoutePath.includes('/statistics')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 48 48"
            >
              <mask
                id="a"
                fill="#fff"
              >
                <path d="M23 12L5 12L5 14L23 14V12Z" />
                <path
                  fill-rule="evenodd"
                  d="M23 16H6V37H5C4.44772 37 4 37.4477 4 38C4 38.5523 4.44772 39 5 39H43C43.5523 39 44 38.5523 44 38C44 37.4477 43.5523 37 43 37H42V16H39V18H40V37H37V25H29V37H8V18H23V16ZM35 37H31V27H35V37Z"
                  clip-rule="evenodd"
                />
                <path d="M39 14V12L43 12V14L39 14Z" />
                <path
                  fill-rule="evenodd"
                  d="M11 32V25H26V32L27 32V34L10 34V32H11ZM13 27H24V32H13V27Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M35 10H27C25.8954 10 25 10.8954 25 12V20C25 21.1046 25.8954 22 27 22H35C36.1046 22 37 21.1046 37 20V12C37 10.8954 36.1046 10 35 10Z"
                />
              </mask>
              <path
                fill="#333"
                d="M32 14V13H30V14H32ZM29 15H28V17H29V15ZM6 13V18H8V13H6ZM40 13V18H42V13H40ZM30 14V18H32V14H30ZM29 17L33 17V15L29 15V17ZM23 12H25V10L23 10V12ZM5 12L5 10L3 10L3 12L5 12ZM5 14L3 14L3 16H5L5 14ZM23 14V16H25V14H23ZM23 16H25V14H23V16ZM6 16V14H4V16H6ZM6 37V39H8V37H6ZM42 37H40V39H42V37ZM42 16H44V14H42V16ZM39 16V14H37V16H39ZM39 18H37V20H39V18ZM40 18H42V16H40V18ZM40 37V39H42V37H40ZM37 37H35V39H37V37ZM37 25H39V23H37V25ZM29 25V23H27V25H29ZM29 37V39H31V37H29ZM8 37H6V39H8V37ZM8 18V16H6V18H8ZM23 18V20H25V18H23ZM39 12V10L37 10V12H39ZM39 14H37V16H39V14ZM43 12H45V10L43 10V12ZM43 14V16L45 16V14H43ZM31 37H29V39H31V37ZM35 37V39H37V37H35ZM31 27V25H29V27H31ZM35 27H37V25H35V27ZM24 27H26V25H24V27ZM13 27V25H11V27H13ZM24 32V34H26V32H24ZM13 32H11V34H13V32ZM11 32V34H13V32H11ZM11 25V23H9V25H11ZM26 25H28V23H26V25ZM26 32H24V34L26 34L26 32ZM27 32H29V30L27 30L27 32ZM27 34V36H29V34H27ZM10 34H8V36H10V34ZM10 32V30H8V32H10ZM23 10L5 10L5 14L23 14V10ZM3 12L3 14L7 14V12L3 12ZM5 16L23 16V12L5 12L5 16ZM25 14V12H21V14H25ZM5 39H6V35H5V39ZM6 38C6 38.5523 5.55229 39 5 39V35C3.34315 35 2 36.3431 2 38H6ZM5 37C5.55229 37 6 37.4477 6 38H2C2 39.6569 3.34315 41 5 41V37ZM42 38C42 37.4477 42.4477 37 43 37V41C44.6569 41 46 39.6569 46 38H42ZM43 39C42.4477 39 42 38.5523 42 38H46C46 36.3431 44.6569 35 43 35V39ZM42 39H43V35H42V39ZM37 16V18H41V16H37ZM39 20H40V16H39V20ZM38 18V37H42V18H38ZM40 35H37V39H40V35ZM29 35H8V39H29V35ZM10 37V18H6V37H10ZM8 20H23V16H8V20ZM25 18V16H21V18H25ZM37 12V14H41V12H37ZM43 10L39 10V14L43 14V10ZM45 14V12H41V14H45ZM39 16L43 16V12L39 12V16ZM31 39H35V35H31V39ZM29 27V37H33V27H29ZM35 25H31V29H35V25ZM37 37V27H33V37H37ZM24 25H13V29H24V25ZM26 32V27H22V32H26ZM13 34H24V30H13V34ZM11 27V32H15V27H11ZM27 30L26 30L26 34L27 34L27 30ZM29 34V32H25V34H29ZM8 32V34H12V32H8ZM11 30H10V34H11V30ZM27 12H35V8H27V12ZM35 12V20H39V12H35ZM35 20H27V24H35V20ZM27 20V12H23V20H27ZM27 20H23C23 22.2091 24.7909 24 27 24V20ZM35 20V24C37.2091 24 39 22.2091 39 20H35ZM35 12H39C39 9.79086 37.2091 8 35 8V12ZM27 8C24.7909 8 23 9.79086 23 12H27V12V8ZM6 18H23V14H6V18ZM8 37V16H4V37H8ZM43 37H5V41H43V37ZM40 16V37H44V16H40ZM39 18H42V14H39V18ZM39 37V25H35V37H39ZM37 23H29V27H37V23ZM27 25V37H31V25H27ZM9 25V32H13V25H9ZM26 23H11V27H26V23ZM28 32V25H24V32H28ZM10 36L27 36V32L10 32V36Z"
                mask="url(#a)"
              />
            </svg>
            الإحصائيات
          </router-link>

          <!-- المسؤولين -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'administratorsByMunicipal',
              params: { municipal_id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/administrators')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6"
              :class="
                this.checkRoutePath.includes('/administrators')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
            المسؤولين
          </router-link>

          <!-- المخزن -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'vaccinesMunicipalsStorage',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/storage')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/storage')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 3642.566 3513.198"
            >
              <path
                d="M1827.579 987.333c-288.09 0-523.12 234.381-523.12 522.471v59.367h1046.24v-59.367c0-288.09-235.03-522.471-523.12-522.471zm-408.177 468.73c27.614-205.007 198.924-352.811 405.47-352.811s377.857 147.804 405.471 352.811h-810.941z"
              />
              <path
                d="m3382.801 1625.003 259.765-320.447L1821.159 0 0 1304.38l265.288 330.68v1878.139h3117.513V1625.003zM1821.159 139.126l1657.932 1187.472-173.844 214.464-1484.06-1067.04L334.786 1540.935l-171.808-214.161L1821.159 139.126zM1268.711 2624.81 859.1 3385.186V1859.442l409.611 765.368zm-312.227-772.872h731.242l-365.622 678.718-365.62-678.718zm941.787 89.142 365.96 683.803-365.96 679.35V1941.08zm52.149-96.211h735.793l-367.896 682.945-367.897-682.945zm789.085 92.685V3307.75l-367.85-682.861 367.85-687.335zM1322.101 2717.99l365.049 682.101H957.052l365.049-682.101zm50.846-93.184 391.009-730.608v1456.459l-391.009-725.851zm945.375 97.409 366.571 684.945h-733.142l366.571-684.945zm534.29 677.876V1731.762H745.993v1668.329H378.395V1648.865L1821.131 613.287l1448.563 1041.52v1745.284h-417.082z"
              />
            </svg>
            المخزن
          </router-link>

          <!-- طلبات المراكز -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{ name: 'vaccinesMunicipalsOrder', params: { id: role.guid } }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/order')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/order')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
            >
              <path
                fill-rule="evenodd"
                d="M58.177 80H8.346A7.155 7.155 0 0 1 .99 73.083V6.916A7.155 7.155 0 0 1 8.346 0h49.831a7.155 7.155 0 0 1 7.358 6.916V18.15a1.991 1.991 0 0 1-3.982 0V6.916A3.176 3.176 0 0 0 58.177 4H8.346a3.174 3.174 0 0 0-3.374 2.916v66.167A3.174 3.174 0 0 0 8.346 76h49.831a2 2 0 1 1 0 4zM37.6 44.149h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 1 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm35.363-40h-7.488a2 2 0 1 1 0-4h7.488a2 2 0 0 1-.004 4h.004zm-17.443 0h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm57.142 37.478c-.1 0-.352-.019-.449-.033-11.029-1.627-21.81-4.838-22.588-23.772h-8.443a2 2 0 0 1-1.567-3.234l14.958-19.151a1.988 1.988 0 0 1 3.135 0l14.956 19.151a2 2 0 0 1-1.567 3.234h-8.518c-.407 10.127 3.465 14.041 11.431 18.213a2.966 2.966 0 0 1-1.352 5.592h.004zM49.435 45.822h6.3a1.994 1.994 0 0 1 1.991 1.991c.061 14.4 5.633 18.774 13.6 20.765-6.156-4.357-9.345-10.038-8.439-20.922a1.992 1.992 0 0 1 1.983-1.834h6.3L60.3 31.912l-10.865 13.91z"
              />
            </svg>
            طلبات المراكز
          </router-link>

          <!-- تسليم الطلبات للمراكز -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'deliveryvaccinesMunicipalsOrder',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/delivery')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/delivery')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 64 64"
              viewBox="0 0 64 64"
            >
              <path
                d="M37.8 4.3c0-.6-.5-1-1-1h-5.9C30.1 1.3 28.2 0 26 0c-3 0-5.3 2.4-5.3 5.3h16.2C37.4 5.3 37.8 4.9 37.8 4.3zM30.1 10.3v-3h-8.4v2.2c0 2.2 1.8 4 4 4h1.2C28.7 13.5 30.1 12.1 30.1 10.3zM46.9 21.3c.2 0 .5.1.7.2l1.3 1.1V19H45v3.6l1.3-1.1C46.4 21.4 46.6 21.3 46.9 21.3zM24.3 15.4L24.2 17h2.4l.2-1.4h-1.2C25.2 15.6 24.8 15.5 24.3 15.4zM42.5 56.1c0 0-.1 0-.2 0l0 0h-.1l-3 .3c-.2 0-.4 0-.6 0-.4-.1-.8-.2-1.1-.5-.5-.4-.8-1-.9-1.6l-.5-5.5c-.1-.6-.2-1.1-.4-1.7-.1-.2-.2-.4-.3-.6L31.2 40l-1.7-2.7h-5.7c-.6 0-1-.5-1-1 0-.6.5-1 1-1h5.3v-6h-1.2c-.4 0-.8-.3-.9-.6-.1-.1-.1-.3-.1-.4 0-.6.5-1 1-1h2.2c.1 0 .3 0 .4.1l.1.1c.1 0 .1.1.2.1l3 2.9c.5.5 1.2.8 1.9.8h6.8c.3 0 .5-.1.7-.3l0 0c.1 0 .1-.1.1-.2.1-.2.2-.4.2-.6 0-.3-.1-.5-.3-.7s-.4-.3-.7-.3h-5.3c-1.4 0-2.8-.6-3.8-1.5l-.1-.1c-.1-.1-.1-.1-.2-.2-.1-.1-.2-.2-.3-.3L32.7 27c-.1-.2-.2-.3-.3-.5l-.3-.6L29 20c0 0 0-.1-.1-.1-.1-.1-.2-.2-.3-.3-.1-.1-.1-.1-.2-.2-.1 0-.1-.1-.2-.1-.1-.1-.2-.1-.3-.1-.1 0-.1-.1-.2-.1S27.5 19 27.4 19c-.1 0-.2 0-.3 0H27h-2.8c-.3 0-.5.1-.8.1-.2.1-.4.2-.5.3 0 0 0 0-.1.1-.2.1-.3.2-.4.4l0 0c-.1.1-.2.3-.3.4 0 .1-.1.1-.1.2-.1.1-.1.3-.1.4V21l-2 18.2L19 47.7c0 .4-.1.7-.2 1.1-.4 1.5-1.1 2.9-2.2 4.1l-2.5 2.5c-.1.1-.2.3-.2.5s.1.5.2.7l5.2 5.2c.2.2.6.3.9.2.1 0 .2-.1.3-.2.1-.1.1-.2.2-.3.1-.2.1-.4 0-.6 0-.1-.1-.2-.1-.3l-1-1.4L19.4 59l0 0c-.7-1-.7-2.2-.1-3.3 0 0 0-.1.1-.1l1.9-2.7c.1-.1.1-.2.2-.3s.1-.2.2-.3c.1-.2.2-.3.2-.5 0-.1.1-.1.1-.2.2-.4.3-.9.4-1.4l1.6-8.9c0-.2.2-.4.4-.6.1-.1.3-.2.4-.2s.1 0 .2 0h.1c.1 0 .3.1.4.1.1.1.3.2.4.3l.7 1 5.7 8.4c.6.9 1 1.9 1.1 3 0 .1 0 .2 0 .3l.6 5.6c0 .1 0 .1.1.1 0 0 0 0 0 .1l.1.1c.1 0 .2.1.3 0l2.4-.9 5.6-2.1c.1 0 .1-.1.2-.1 0-.1.1-.1.1-.2 0-.2-.1-.2-.1-.3C42.6 56.1 42.6 56.1 42.5 56.1z"
              />
              <path
                d="M55.2 19h-4.3v5.8c0 .4-.2.8-.6.9-.1.1-.3.1-.4.1-.2 0-.5-.1-.7-.2l-2.3-1.9-2.3 1.9c-.3.3-.7.3-1.1.1-.4-.2-.6-.5-.6-.9V19h-4.3c-1.1 0-2 .9-2 2v6c.2.1.5.1.7.1h5.3c.8 0 1.6.3 2.2.9s.9 1.3.9 2.2c0 .8-.3 1.6-.9 2.2-.1.1-.3.2-.4.3 0 0 0 0-.1.1S44.1 32.9 44 33c-.1 0-.1.1-.2.1-.1 0-.1 0-.2.1-.3.1-.6.2-1 .2h-5.8V35c.3.8 1 1.2 1.9 1.2h16.6c1.1 0 2-.9 2-2V21C57.2 19.9 56.3 19 55.2 19zM59.9 62H4.1c-.6 0-1 .5-1 1s.5 1 1 1H60c.6 0 1-.5 1-1S60.5 62 59.9 62z"
              />
            </svg>
            تسليم الطلبات للمراكز
          </router-link>

          <!--  طلبات جاهزة للاستلام -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'municipalsOrderReadyToDelivery',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/ready-to-delivery')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current"
              :class="
                this.checkRoutePath.includes('/ready-to-delivery')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polygon
                points="12 23.5 23 18.5 23 8.5 12 13.5 1 8.5 1 18.5 12 23.5"
              />
              <line
                x1="6"
                x2="1"
                y1="6.228"
                y2="8.5"
              />
              <line
                x1="23"
                x2="18"
                y1="8.5"
                y2="6.228"
              />
              <line
                x1="12"
                x2="12"
                y1="13.5"
                y2="23.5"
              />
              <line
                x1="12"
                x2="12"
                y1="8.5"
                y2="0.5"
              />
              <polyline points="16 4.5 12 8.5 8 4.5" />
            </svg>
            طلبات جاهزة للاستلام
          </router-link>

          <!-- التألف -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{ name: 'SpoiledMunicipals', params: { id: role.guid } }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/spoiled')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-2 stroke-current"
              :class="
                this.checkRoutePath.includes('/spoiled')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              width="256"
              height="256"
              viewBox="0 0 256 256"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M96 72V48"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M160 208V184"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M72 96H48"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M208 160H184"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M71.0289 128.402L59.7151 139.716C52.2174 147.218 48.0062 157.391 48.0078 167.998C48.0094 178.605 52.2235 188.776 59.7235 196.276C67.2235 203.776 77.3953 207.99 88.0019 207.992C98.6085 207.994 108.781 203.782 116.284 196.285L127.597 184.971M184.97 127.598L196.284 116.285C203.781 108.782 207.993 98.6095 207.991 88.0028C207.989 77.3962 203.775 67.2245 196.275 59.7245C188.775 52.2245 178.604 48.0104 167.997 48.0088C157.39 48.0072 147.217 52.2183 139.715 59.7161L128.401 71.0298"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            التألف
          </router-link>

          <!-- اللقاحات المسترجعة -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'recoveryVaccineByMunicipalities',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/recovery')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/recovery')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              fill="#000000"
              width="800px"
              height="800px"
              viewBox="0 0 51 51"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <polygon
                  points="9.81,29 12.63,25.06 16.24,20.02 12.63,20.02 12.63,18.23 25.54,10.78 38.45,18.23 38.45,22.96 41.19,19.14 
		43.95,23.01 43.95,15.06 25.54,4.43 7.13,15.06 7.13,20.02 3.39,20.02 7.13,25.25 	"
                />
                <polygon
                  points="43.95,25.92 41.19,22.06 38.45,25.88 34.76,31.04 38.45,31.04 38.45,33.14 25.54,40.59 12.63,33.14 12.63,28.02 
		9.81,31.96 7.13,28.22 7.13,36.32 25.54,46.94 43.95,36.32 43.95,31.04 47.61,31.04 	"
                />
                <path
                  d="M16.96,25.5c0,4.74,3.84,8.58,8.58,8.58c4.74,0,8.58-3.84,8.58-8.58c0-4.74-3.84-8.58-8.58-8.58
		C20.8,16.92,16.96,20.76,16.96,25.5z M29.96,24.5v2h-3.42v3.42h-2V26.5h-3.42v-2h3.42v-3.42h2v3.42H29.96z"
                />
              </g>
            </svg>

            اللقاحات المسترجعة
          </router-link>

          <!-- مراكز التطعيم -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'vaccinationCentersByMunicipal',
              params: { municipal_id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/vaccination-centers')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current stroke-2"
              :class="
                this.checkRoutePath.includes('/vaccination-centers')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="48"
              height="48"
              fill="none"
              viewBox="0 0 48 48"
            >
              <mask
                id="a"
                fill="#fff"
              >
                <path d="M23 12L5 12L5 14L23 14V12Z" />
                <path
                  fill-rule="evenodd"
                  d="M23 16H6V37H5C4.44772 37 4 37.4477 4 38C4 38.5523 4.44772 39 5 39H43C43.5523 39 44 38.5523 44 38C44 37.4477 43.5523 37 43 37H42V16H39V18H40V37H37V25H29V37H8V18H23V16ZM35 37H31V27H35V37Z"
                  clip-rule="evenodd"
                />
                <path d="M39 14V12L43 12V14L39 14Z" />
                <path
                  fill-rule="evenodd"
                  d="M11 32V25H26V32L27 32V34L10 34V32H11ZM13 27H24V32H13V27Z"
                  clip-rule="evenodd"
                />
                <path
                  d="M35 10H27C25.8954 10 25 10.8954 25 12V20C25 21.1046 25.8954 22 27 22H35C36.1046 22 37 21.1046 37 20V12C37 10.8954 36.1046 10 35 10Z"
                />
              </mask>
              <path
                fill="#333"
                d="M32 14V13H30V14H32ZM29 15H28V17H29V15ZM6 13V18H8V13H6ZM40 13V18H42V13H40ZM30 14V18H32V14H30ZM29 17L33 17V15L29 15V17ZM23 12H25V10L23 10V12ZM5 12L5 10L3 10L3 12L5 12ZM5 14L3 14L3 16H5L5 14ZM23 14V16H25V14H23ZM23 16H25V14H23V16ZM6 16V14H4V16H6ZM6 37V39H8V37H6ZM42 37H40V39H42V37ZM42 16H44V14H42V16ZM39 16V14H37V16H39ZM39 18H37V20H39V18ZM40 18H42V16H40V18ZM40 37V39H42V37H40ZM37 37H35V39H37V37ZM37 25H39V23H37V25ZM29 25V23H27V25H29ZM29 37V39H31V37H29ZM8 37H6V39H8V37ZM8 18V16H6V18H8ZM23 18V20H25V18H23ZM39 12V10L37 10V12H39ZM39 14H37V16H39V14ZM43 12H45V10L43 10V12ZM43 14V16L45 16V14H43ZM31 37H29V39H31V37ZM35 37V39H37V37H35ZM31 27V25H29V27H31ZM35 27H37V25H35V27ZM24 27H26V25H24V27ZM13 27V25H11V27H13ZM24 32V34H26V32H24ZM13 32H11V34H13V32ZM11 32V34H13V32H11ZM11 25V23H9V25H11ZM26 25H28V23H26V25ZM26 32H24V34L26 34L26 32ZM27 32H29V30L27 30L27 32ZM27 34V36H29V34H27ZM10 34H8V36H10V34ZM10 32V30H8V32H10ZM23 10L5 10L5 14L23 14V10ZM3 12L3 14L7 14V12L3 12ZM5 16L23 16V12L5 12L5 16ZM25 14V12H21V14H25ZM5 39H6V35H5V39ZM6 38C6 38.5523 5.55229 39 5 39V35C3.34315 35 2 36.3431 2 38H6ZM5 37C5.55229 37 6 37.4477 6 38H2C2 39.6569 3.34315 41 5 41V37ZM42 38C42 37.4477 42.4477 37 43 37V41C44.6569 41 46 39.6569 46 38H42ZM43 39C42.4477 39 42 38.5523 42 38H46C46 36.3431 44.6569 35 43 35V39ZM42 39H43V35H42V39ZM37 16V18H41V16H37ZM39 20H40V16H39V20ZM38 18V37H42V18H38ZM40 35H37V39H40V35ZM29 35H8V39H29V35ZM10 37V18H6V37H10ZM8 20H23V16H8V20ZM25 18V16H21V18H25ZM37 12V14H41V12H37ZM43 10L39 10V14L43 14V10ZM45 14V12H41V14H45ZM39 16L43 16V12L39 12V16ZM31 39H35V35H31V39ZM29 27V37H33V27H29ZM35 25H31V29H35V25ZM37 37V27H33V37H37ZM24 25H13V29H24V25ZM26 32V27H22V32H26ZM13 34H24V30H13V34ZM11 27V32H15V27H11ZM27 30L26 30L26 34L27 34L27 30ZM29 34V32H25V34H29ZM8 32V34H12V32H8ZM11 30H10V34H11V30ZM27 12H35V8H27V12ZM35 12V20H39V12H35ZM35 20H27V24H35V20ZM27 20V12H23V20H27ZM27 20H23C23 22.2091 24.7909 24 27 24V20ZM35 20V24C37.2091 24 39 22.2091 39 20H35ZM35 12H39C39 9.79086 37.2091 8 35 8V12ZM27 8C24.7909 8 23 9.79086 23 12H27V12V8ZM6 18H23V14H6V18ZM8 37V16H4V37H8ZM43 37H5V41H43V37ZM40 16V37H44V16H40ZM39 18H42V14H39V18ZM39 37V25H35V37H39ZM37 23H29V27H37V23ZM27 25V37H31V25H27ZM9 25V32H13V25H9ZM26 23H11V27H26V23ZM28 32V25H24V32H28ZM10 36L27 36V32L10 32V36Z"
                mask="url(#a)"
              />
            </svg>

            مراكز التطعيم
          </router-link>

          <!-- المسجلين بالبلدية -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'citizens_municipal',
              params: { municipal_id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/citizens')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/citizens')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 50 50"
              viewBox="0 0 50 50"
            >
              <path
                d="M24.3141,5.9217c-1.1045,0-2,0.8955-2,2v1.0835c0,3.0571-2.331,5.5801-5.3088,5.8854h-6.6319c-2.9783-0.3052-5.3093-2.8283-5.3093-5.8854V7.9217c0-2.6419-4-2.6449-4,0v1.0835c0,4.4979,3.0131,8.3001,7.1251,9.5096v11.2928c-0.0042,0.0524-0.0157,0.1027-0.0157,0.1561v16c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h2.9585v15.0419c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h0.0573v-12.407c4.1119-1.2095,7.1249-5.0116,7.1249-9.5096V7.9217C26.3141,6.8173,25.4186,5.9217,24.3141,5.9217z"
              />
              <path
                d="M13.6893 12.9219c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4C8.4061 4.9219 8.3991 12.9219 13.6893 12.9219zM6.06 8.736v.27M4 17.366H2.26v-.5C1.8611 16.8992 1.3929 16.8715 1 16.736v4.72h6.19v-2.22C6.01 18.796 4.94 18.166 4 17.366zM47.52 17.366v-1.33h-1.18v-3.24H45.1v3.24h-1.17v-1.97h-2.51v1.97H40.3v-9.69h-.62v-2.81h-.96v-1.5h-2.7v1.5h-.96v2.81h-.61v11.02h-.92v-7.93H27.29c-.06 1.73-.54 3.39-1.37 4.85.22.16.36.43.36.75 0 .52-.4.94-.89.94-.18 0-.35-.05-.49-.15-1.22 1.51-2.83 2.71-4.71 3.41v2.22H49v-4.09H47.52zM28.2 15.976c-.51 0-.92-.42-.92-.94 0-.53.41-.94.92-.94.49 0 .89.41.89.94C29.09 15.556 28.69 15.976 28.2 15.976zM28.2 12.956c-.51 0-.92-.42-.92-.93 0-.54.41-.96.92-.96.49 0 .89.42.89.96C29.09 12.536 28.69 12.956 28.2 12.956zM30.98 15.976c-.5 0-.89-.42-.89-.94 0-.53.39-.94.89-.94s.92.41.92.94C31.9 15.556 31.48 15.976 30.98 15.976zM30.98 12.956c-.5 0-.89-.42-.89-.93 0-.54.39-.96.89-.96s.92.42.92.96C31.9 12.536 31.48 12.956 30.98 12.956zM36.34 16.576h-1.06v-8.12h1.06V16.576zM37.89 16.576h-1.03v-8.12h1.03V16.576zM39.46 16.576h-1.05v-8.12h1.05V16.576z"
              />
              <rect
                width="2.259"
                height="3.54"
                x="30.459"
                y="4.81"
              />
              <path d="M1.355,16.756" />
            </svg>
            المسجلين بالبلدية
          </router-link>

          <!-- طلبات النقل داخل البلدية -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'internalTransferRequestsByMuncipal',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/internal-transfer-requests')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/internal-transfer-requests')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              fill="#000000"
              xmlns="http://www.w3.org/2000/svg"
              width="800px"
              height="800px"
              viewBox="0 0 100 100"
              enable-background="new 0 0 100 100"
              xml:space="preserve"
            >
              <path
                d="M77.4,78.1H40.5c-1.2,0-2.3-1-2.3-2.2c0,0,0-0.1,0-0.1v-4.6c0-1.2,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0h36.9
              c1.2,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1v4.6C79.8,77,78.8,78.1,77.4,78.1C77.5,78.1,77.5,78.1,77.4,78.1z"
              />
              <path
                d="M26.6,78.1H22c-1.2,0-2.3-1-2.3-2.2c0,0,0-0.1,0-0.1v-4.6c0-1.2,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0h4.6
              c1.2,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1v4.6C29,77,28,78,26.8,78.1C26.7,78.1,26.7,78.1,26.6,78.1z"
              />
              <path
                d="M53.8,57.6c-1.2,0-2.3-1-2.3-2.2c0,0,0-0.1,0-0.1v-4.6c0-1.2,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0h23.6
              c1.2,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1v4.6c0,1.2-1,2.3-2.2,2.3c0,0-0.1,0-0.1,0H53.8z"
              />
              <path
                d="M62.6,37.1c-1.2,0-2.3-1-2.3-2.2c0,0,0-0.1,0-0.1v-4.6c0-1.2,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0h14.8
              c1.2,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1v4.6c0,1.2-1,2.3-2.2,2.3c0,0-0.1,0-0.1,0H62.6z"
              />
              <path
                d="M20.8,58.2C19.6,47.5,28,36.4,38,34.5l2.7-0.6c0.5-0.1,0.9-0.6,0.8-1.2c0-0.3-0.2-0.5-0.4-0.6l-6.7-4.5
              c-0.7-0.5-0.8-1.4-0.3-2c0,0,0,0,0-0.1l1.7-2.5c0.4-0.7,1.4-0.9,2-0.4c0,0,0,0,0.1,0L54,33.5c0.7,0.4,0.9,1.4,0.4,2c0,0,0,0,0,0.1
              l-11,16.2c-0.4,0.7-1.4,0.9-2,0.4c0,0,0,0-0.1,0l-2.5-1.7c-0.7-0.4-0.9-1.4-0.4-2c0,0,0,0,0-0.1l4.4-6.7c0.3-0.4,0.3-1.1-0.2-1.4
              c-0.2-0.2-0.5-0.3-0.8-0.2l-1.6,0.3c-7.8,1.5-14.4,10.3-13.7,17.9c0,0.7-1.1,1.7-1.9,1.9h-1.9C21.8,60.3,20.8,59.1,20.8,58.2z"
              />
            </svg>

            طلبات النقل داخل البلدية
          </router-link>

          <!-- طلبات استيراد المسجلين -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'importRequestsByMuncipal',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/import-requests')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/import-requests')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              fill="#000000"
              xmlns="http://www.w3.org/2000/svg"
              width="800px"
              height="800px"
              viewBox="0 0 100 100"
              enable-background="new 0 0 100 100"
              xml:space="preserve"
            >
              <path
                d="M77.8,77.4H40.8c-1.2,0-2.3-1-2.3-2.2c0,0,0-0.1,0-0.1v-4.6c0-1.2,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0h36.9
            c1.2,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1v4.6C80.1,76.3,79.1,77.4,77.8,77.4C77.8,77.4,77.8,77.4,77.8,77.4z"
              />
              <path
                d="M26.9,77.4h-4.6c-1.2,0-2.3-1-2.3-2.2c0,0,0-0.1,0-0.1v-4.6c0-1.2,1-2.3,2.2-2.3c0,0,0.1,0,0.1,0h4.6
            c1.2,0,2.3,1,2.3,2.2c0,0,0,0.1,0,0.1v4.6c0.1,1.2-0.8,2.2-2,2.3C27.1,77.4,27,77.4,26.9,77.4z"
              />
              <path
                d="M24.4,48.5c6.8-11.7,22.9-17,33.6-11.8l2.9,1.3c1,0.5,2-0.6,1.7-1.6L59.8,27c-0.3-1,0.3-2,1.2-2.4l3.4-1.3
            c0.8-0.4,1.7,0,2.1,0.8c0,0.1,0.1,0.2,0.1,0.3l6.8,22.7c0.3,1-0.2,2.1-1.2,2.4l-22,8.6c-0.8,0.4-1.7,0-2.1-0.8
            c0-0.1-0.1-0.2-0.1-0.3l-1.1-3.5c-0.3-1,0.2-2.1,1.2-2.4l9-3.6c0.7-0.2,1-0.9,0.8-1.6c-0.1-0.3-0.3-0.6-0.6-0.7l-1.7-0.8
            c-8.3-4.1-21,0.1-26,8.4c-0.5,0.8-2.3,1-3.2,0.6l-1.7-1.6C23.8,51.4,23.9,49.4,24.4,48.5z"
              />
            </svg>

            طلبات استيراد المسجلين
          </router-link>

          <!-- طلبات تصدير المسجلين -->
          <router-link
            v-if="role.id == '1c74f9e8-faba-4051-bebc-db08ed11dbcc'"
            :to="{
              name: 'exportRequestsByMuncipal',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/export-requests')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/export-requests')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              fill="#000000"
              width="800px"
              height="800px"
              viewBox="0 0 100 100"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M46.72,20.52a1.73,1.73,0,0,1,2.47,0l13.46,13a1.62,1.62,0,0,1,0,2.43L49.19,49a1.72,1.72,0,0,1-2.47,0l-2.47-2.42a1.62,1.62,0,0,1,0-2.43L48.46,40a1.12,1.12,0,0,0-.82-1.9H24.83A1.85,1.85,0,0,1,23,36.38V32.92a1.92,1.92,0,0,1,1.83-1.74H47.64a1.1,1.1,0,0,0,.82-1.9L44.25,25.2a1.62,1.62,0,0,1,0-2.43ZM39.48,51.05a1.73,1.73,0,0,0-2.48,0l-13.45,13a1.62,1.62,0,0,0,0,2.43L37,79.48a1.74,1.74,0,0,0,2.48,0L42,77.05a1.61,1.61,0,0,0,0-2.42l-4.21-4.08a1.12,1.12,0,0,1,.82-1.91H49.42A15.63,15.63,0,0,1,49,65a16.17,16.17,0,0,1,.34-3.29H38.56a1.1,1.1,0,0,1-.82-1.91L42,55.73a1.62,1.62,0,0,0,0-2.43ZM53,65A12,12,0,1,1,65,77,12,12,0,0,1,53,65Zm19.52-2.81-8.07,8.08a1.46,1.46,0,0,1-2.15,0l-3.9-3.91a.69.69,0,0,1,0-1.07l1.07-1.08a.71.71,0,0,1,1.08,0L63.37,67l6.93-6.93a.7.7,0,0,1,1.08,0l1.07,1.08A.66.66,0,0,1,72.52,62.19Z"
                fill-rule="evenodd"
              />
            </svg>

            طلبات تصدير المسجلين
          </router-link>

          <!-- END  إدارة البلدية     -->

          <!-- START 03a85b59-5047-48bd-a681-87d38bc207e5  إدارة مركز التطعيم    -->

          <!-- لوحة التحكم -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{ name: 'dashboardVaccinationCenters' }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/dashboard')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6"
              :class="
                this.checkRoutePath.includes('/dashboard')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
              />
            </svg>
            لوحة التحكم
          </router-link>

          <!-- المسجلين بالمركز -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{
              name: 'citizens_vaccination_center',
              params: { vaccination_center_id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/citizens')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/citizens')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 50 50"
              viewBox="0 0 50 50"
            >
              <path
                d="M24.3141,5.9217c-1.1045,0-2,0.8955-2,2v1.0835c0,3.0571-2.331,5.5801-5.3088,5.8854h-6.6319c-2.9783-0.3052-5.3093-2.8283-5.3093-5.8854V7.9217c0-2.6419-4-2.6449-4,0v1.0835c0,4.4979,3.0131,8.3001,7.1251,9.5096v11.2928c-0.0042,0.0524-0.0157,0.1027-0.0157,0.1561v16c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h2.9585v15.0419c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h0.0573v-12.407c4.1119-1.2095,7.1249-5.0116,7.1249-9.5096V7.9217C26.3141,6.8173,25.4186,5.9217,24.3141,5.9217z"
              />
              <path
                d="M13.6893 12.9219c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4C8.4061 4.9219 8.3991 12.9219 13.6893 12.9219zM6.06 8.736v.27M4 17.366H2.26v-.5C1.8611 16.8992 1.3929 16.8715 1 16.736v4.72h6.19v-2.22C6.01 18.796 4.94 18.166 4 17.366zM47.52 17.366v-1.33h-1.18v-3.24H45.1v3.24h-1.17v-1.97h-2.51v1.97H40.3v-9.69h-.62v-2.81h-.96v-1.5h-2.7v1.5h-.96v2.81h-.61v11.02h-.92v-7.93H27.29c-.06 1.73-.54 3.39-1.37 4.85.22.16.36.43.36.75 0 .52-.4.94-.89.94-.18 0-.35-.05-.49-.15-1.22 1.51-2.83 2.71-4.71 3.41v2.22H49v-4.09H47.52zM28.2 15.976c-.51 0-.92-.42-.92-.94 0-.53.41-.94.92-.94.49 0 .89.41.89.94C29.09 15.556 28.69 15.976 28.2 15.976zM28.2 12.956c-.51 0-.92-.42-.92-.93 0-.54.41-.96.92-.96.49 0 .89.42.89.96C29.09 12.536 28.69 12.956 28.2 12.956zM30.98 15.976c-.5 0-.89-.42-.89-.94 0-.53.39-.94.89-.94s.92.41.92.94C31.9 15.556 31.48 15.976 30.98 15.976zM30.98 12.956c-.5 0-.89-.42-.89-.93 0-.54.39-.96.89-.96s.92.42.92.96C31.9 12.536 31.48 12.956 30.98 12.956zM36.34 16.576h-1.06v-8.12h1.06V16.576zM37.89 16.576h-1.03v-8.12h1.03V16.576zM39.46 16.576h-1.05v-8.12h1.05V16.576z"
              />
              <rect
                width="2.259"
                height="3.54"
                x="30.459"
                y="4.81"
              />
              <path d="M1.355,16.756" />
            </svg>
            المسجلين بالمركز
          </router-link>

          <!-- المسجلين خارج المركز -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{
              name: 'citizens_vaccination_center_not_belong',
              params: { vaccination_center_id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/not-belong')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/not-belong')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 50 50"
              viewBox="0 0 50 50"
            >
              <path
                d="M24.3141,5.9217c-1.1045,0-2,0.8955-2,2v1.0835c0,3.0571-2.331,5.5801-5.3088,5.8854h-6.6319c-2.9783-0.3052-5.3093-2.8283-5.3093-5.8854V7.9217c0-2.6419-4-2.6449-4,0v1.0835c0,4.4979,3.0131,8.3001,7.1251,9.5096v11.2928c-0.0042,0.0524-0.0157,0.1027-0.0157,0.1561v16c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h2.9585v15.0419c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h0.0573v-12.407c4.1119-1.2095,7.1249-5.0116,7.1249-9.5096V7.9217C26.3141,6.8173,25.4186,5.9217,24.3141,5.9217z"
              />
              <path
                d="M13.6893 12.9219c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4C8.4061 4.9219 8.3991 12.9219 13.6893 12.9219zM6.06 8.736v.27M4 17.366H2.26v-.5C1.8611 16.8992 1.3929 16.8715 1 16.736v4.72h6.19v-2.22C6.01 18.796 4.94 18.166 4 17.366zM47.52 17.366v-1.33h-1.18v-3.24H45.1v3.24h-1.17v-1.97h-2.51v1.97H40.3v-9.69h-.62v-2.81h-.96v-1.5h-2.7v1.5h-.96v2.81h-.61v11.02h-.92v-7.93H27.29c-.06 1.73-.54 3.39-1.37 4.85.22.16.36.43.36.75 0 .52-.4.94-.89.94-.18 0-.35-.05-.49-.15-1.22 1.51-2.83 2.71-4.71 3.41v2.22H49v-4.09H47.52zM28.2 15.976c-.51 0-.92-.42-.92-.94 0-.53.41-.94.92-.94.49 0 .89.41.89.94C29.09 15.556 28.69 15.976 28.2 15.976zM28.2 12.956c-.51 0-.92-.42-.92-.93 0-.54.41-.96.92-.96.49 0 .89.42.89.96C29.09 12.536 28.69 12.956 28.2 12.956zM30.98 15.976c-.5 0-.89-.42-.89-.94 0-.53.39-.94.89-.94s.92.41.92.94C31.9 15.556 31.48 15.976 30.98 15.976zM30.98 12.956c-.5 0-.89-.42-.89-.93 0-.54.39-.96.89-.96s.92.42.92.96C31.9 12.536 31.48 12.956 30.98 12.956zM36.34 16.576h-1.06v-8.12h1.06V16.576zM37.89 16.576h-1.03v-8.12h1.03V16.576zM39.46 16.576h-1.05v-8.12h1.05V16.576z"
              />
              <rect
                width="2.259"
                height="3.54"
                x="30.459"
                y="4.81"
              />
              <path d="M1.355,16.756" />
            </svg>
            المسجلين خارج المركز
          </router-link>

          <!-- التقارير -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{ name: 'reportVaccinationCenters' }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/report')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/report')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 50 50"
              viewBox="0 0 50 50"
            >
              <path
                d="M24.3141,5.9217c-1.1045,0-2,0.8955-2,2v1.0835c0,3.0571-2.331,5.5801-5.3088,5.8854h-6.6319c-2.9783-0.3052-5.3093-2.8283-5.3093-5.8854V7.9217c0-2.6419-4-2.6449-4,0v1.0835c0,4.4979,3.0131,8.3001,7.1251,9.5096v11.2928c-0.0042,0.0524-0.0157,0.1027-0.0157,0.1561v16c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h2.9585v15.0419c0,1.1045,0.8955,2,2,2s2-0.8955,2-2V30.9219h0.0573v-12.407c4.1119-1.2095,7.1249-5.0116,7.1249-9.5096V7.9217C26.3141,6.8173,25.4186,5.9217,24.3141,5.9217z"
              />
              <path
                d="M13.6893 12.9219c2.2091 0 4-1.7909 4-4 0-2.2092-1.7909-4-4-4C8.4061 4.9219 8.3991 12.9219 13.6893 12.9219zM6.06 8.736v.27M4 17.366H2.26v-.5C1.8611 16.8992 1.3929 16.8715 1 16.736v4.72h6.19v-2.22C6.01 18.796 4.94 18.166 4 17.366zM47.52 17.366v-1.33h-1.18v-3.24H45.1v3.24h-1.17v-1.97h-2.51v1.97H40.3v-9.69h-.62v-2.81h-.96v-1.5h-2.7v1.5h-.96v2.81h-.61v11.02h-.92v-7.93H27.29c-.06 1.73-.54 3.39-1.37 4.85.22.16.36.43.36.75 0 .52-.4.94-.89.94-.18 0-.35-.05-.49-.15-1.22 1.51-2.83 2.71-4.71 3.41v2.22H49v-4.09H47.52zM28.2 15.976c-.51 0-.92-.42-.92-.94 0-.53.41-.94.92-.94.49 0 .89.41.89.94C29.09 15.556 28.69 15.976 28.2 15.976zM28.2 12.956c-.51 0-.92-.42-.92-.93 0-.54.41-.96.92-.96.49 0 .89.42.89.96C29.09 12.536 28.69 12.956 28.2 12.956zM30.98 15.976c-.5 0-.89-.42-.89-.94 0-.53.39-.94.89-.94s.92.41.92.94C31.9 15.556 31.48 15.976 30.98 15.976zM30.98 12.956c-.5 0-.89-.42-.89-.93 0-.54.39-.96.89-.96s.92.42.92.96C31.9 12.536 31.48 12.956 30.98 12.956zM36.34 16.576h-1.06v-8.12h1.06V16.576zM37.89 16.576h-1.03v-8.12h1.03V16.576zM39.46 16.576h-1.05v-8.12h1.05V16.576z"
              />
              <rect
                width="2.259"
                height="3.54"
                x="30.459"
                y="4.81"
              />
              <path d="M1.355,16.756" />
            </svg>
            التقارير
          </router-link>

          <!-- المخزن -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{
              name: 'vaccinesVaccinationCentersStorage',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/storage')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/storage')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 3642.566 3513.198"
            >
              <path
                d="M1827.579 987.333c-288.09 0-523.12 234.381-523.12 522.471v59.367h1046.24v-59.367c0-288.09-235.03-522.471-523.12-522.471zm-408.177 468.73c27.614-205.007 198.924-352.811 405.47-352.811s377.857 147.804 405.471 352.811h-810.941z"
              />
              <path
                d="m3382.801 1625.003 259.765-320.447L1821.159 0 0 1304.38l265.288 330.68v1878.139h3117.513V1625.003zM1821.159 139.126l1657.932 1187.472-173.844 214.464-1484.06-1067.04L334.786 1540.935l-171.808-214.161L1821.159 139.126zM1268.711 2624.81 859.1 3385.186V1859.442l409.611 765.368zm-312.227-772.872h731.242l-365.622 678.718-365.62-678.718zm941.787 89.142 365.96 683.803-365.96 679.35V1941.08zm52.149-96.211h735.793l-367.896 682.945-367.897-682.945zm789.085 92.685V3307.75l-367.85-682.861 367.85-687.335zM1322.101 2717.99l365.049 682.101H957.052l365.049-682.101zm50.846-93.184 391.009-730.608v1456.459l-391.009-725.851zm945.375 97.409 366.571 684.945h-733.142l366.571-684.945zm534.29 677.876V1731.762H745.993v1668.329H378.395V1648.865L1821.131 613.287l1448.563 1041.52v1745.284h-417.082z"
              />
            </svg>
            المخزن
          </router-link>

          <!-- طلبات الامداد -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{
              name: 'vaccinesVaccinationCentersOrder',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/order')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/order')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
            >
              <path
                fill-rule="evenodd"
                d="M58.177 80H8.346A7.155 7.155 0 0 1 .99 73.083V6.916A7.155 7.155 0 0 1 8.346 0h49.831a7.155 7.155 0 0 1 7.358 6.916V18.15a1.991 1.991 0 0 1-3.982 0V6.916A3.176 3.176 0 0 0 58.177 4H8.346a3.174 3.174 0 0 0-3.374 2.916v66.167A3.174 3.174 0 0 0 8.346 76h49.831a2 2 0 1 1 0 4zM37.6 44.149h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 1 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm35.363-40h-7.488a2 2 0 1 1 0-4h7.488a2 2 0 0 1-.004 4h.004zm-17.443 0h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm57.142 37.478c-.1 0-.352-.019-.449-.033-11.029-1.627-21.81-4.838-22.588-23.772h-8.443a2 2 0 0 1-1.567-3.234l14.958-19.151a1.988 1.988 0 0 1 3.135 0l14.956 19.151a2 2 0 0 1-1.567 3.234h-8.518c-.407 10.127 3.465 14.041 11.431 18.213a2.966 2.966 0 0 1-1.352 5.592h.004zM49.435 45.822h6.3a1.994 1.994 0 0 1 1.991 1.991c.061 14.4 5.633 18.774 13.6 20.765-6.156-4.357-9.345-10.038-8.439-20.922a1.992 1.992 0 0 1 1.983-1.834h6.3L60.3 31.912l-10.865 13.91z"
              />
            </svg>
            طلبات الامداد
          </router-link>

          <!--  طلبات جاهزة للاستلام -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{
              name: 'vaccinationCenterOrderReadyToDelivery',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/ready-to-delivery')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-current"
              :class="
                this.checkRoutePath.includes('/ready-to-delivery')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <polygon
                points="12 23.5 23 18.5 23 8.5 12 13.5 1 8.5 1 18.5 12 23.5"
              />
              <line
                x1="6"
                x2="1"
                y1="6.228"
                y2="8.5"
              />
              <line
                x1="23"
                x2="18"
                y1="8.5"
                y2="6.228"
              />
              <line
                x1="12"
                x2="12"
                y1="13.5"
                y2="23.5"
              />
              <line
                x1="12"
                x2="12"
                y1="8.5"
                y2="0.5"
              />
              <polyline points="16 4.5 12 8.5 8 4.5" />
            </svg>
            طلبات جاهزة للاستلام
          </router-link>

          <!-- التألف -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{
              name: 'SpoiledVaccinationCenters',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/spoiled')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-2 stroke-current"
              :class="
                this.checkRoutePath.includes('/spoiled')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              width="256"
              height="256"
              viewBox="0 0 256 256"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M96 72V48"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M160 208V184"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M72 96H48"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M208 160H184"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M71.0289 128.402L59.7151 139.716C52.2174 147.218 48.0062 157.391 48.0078 167.998C48.0094 178.605 52.2235 188.776 59.7235 196.276C67.2235 203.776 77.3953 207.99 88.0019 207.992C98.6085 207.994 108.781 203.782 116.284 196.285L127.597 184.971M184.97 127.598L196.284 116.285C203.781 108.782 207.993 98.6095 207.991 88.0028C207.989 77.3962 203.775 67.2245 196.275 59.7245C188.775 52.2245 178.604 48.0104 167.997 48.0088C157.39 48.0072 147.217 52.2183 139.715 59.7161L128.401 71.0298"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            التألف
          </router-link>

          <!-- اللقاحات المسترجعة -->
          <router-link
            v-if="role.id == '03a85b59-5047-48bd-a681-87d38bc207e5'"
            :to="{
              name: 'recoveryVaccineByVaccinationCenters',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/recovery')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/recovery')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              fill="#000000"
              width="800px"
              height="800px"
              viewBox="0 0 51 51"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g>
                <polygon
                  points="9.81,29 12.63,25.06 16.24,20.02 12.63,20.02 12.63,18.23 25.54,10.78 38.45,18.23 38.45,22.96 41.19,19.14 
		43.95,23.01 43.95,15.06 25.54,4.43 7.13,15.06 7.13,20.02 3.39,20.02 7.13,25.25 	"
                />
                <polygon
                  points="43.95,25.92 41.19,22.06 38.45,25.88 34.76,31.04 38.45,31.04 38.45,33.14 25.54,40.59 12.63,33.14 12.63,28.02 
		9.81,31.96 7.13,28.22 7.13,36.32 25.54,46.94 43.95,36.32 43.95,31.04 47.61,31.04 	"
                />
                <path
                  d="M16.96,25.5c0,4.74,3.84,8.58,8.58,8.58c4.74,0,8.58-3.84,8.58-8.58c0-4.74-3.84-8.58-8.58-8.58
		C20.8,16.92,16.96,20.76,16.96,25.5z M29.96,24.5v2h-3.42v3.42h-2V26.5h-3.42v-2h3.42v-3.42h2v3.42H29.96z"
                />
              </g>
            </svg>

            اللقاحات المسترجعة
          </router-link>

          <!-- END  إدارة مركز التطعيم     -->

          <!-- START 13D34058-124E-4D83-8A5D-9127E9E6C2D7  إدارة الإمداد     -->

          <!-- المخزن -->
          <router-link
            v-if="role.id == '13d34058-124e-4d83-8a5d-9127e9e6c2d7'"
            :to="{ name: 'storageMedicalsupplies', params: { id: role.guid } }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/storage')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/storage')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 3642.566 3513.198"
            >
              <path
                d="M1827.579 987.333c-288.09 0-523.12 234.381-523.12 522.471v59.367h1046.24v-59.367c0-288.09-235.03-522.471-523.12-522.471zm-408.177 468.73c27.614-205.007 198.924-352.811 405.47-352.811s377.857 147.804 405.471 352.811h-810.941z"
              />
              <path
                d="m3382.801 1625.003 259.765-320.447L1821.159 0 0 1304.38l265.288 330.68v1878.139h3117.513V1625.003zM1821.159 139.126l1657.932 1187.472-173.844 214.464-1484.06-1067.04L334.786 1540.935l-171.808-214.161L1821.159 139.126zM1268.711 2624.81 859.1 3385.186V1859.442l409.611 765.368zm-312.227-772.872h731.242l-365.622 678.718-365.62-678.718zm941.787 89.142 365.96 683.803-365.96 679.35V1941.08zm52.149-96.211h735.793l-367.896 682.945-367.897-682.945zm789.085 92.685V3307.75l-367.85-682.861 367.85-687.335zM1322.101 2717.99l365.049 682.101H957.052l365.049-682.101zm50.846-93.184 391.009-730.608v1456.459l-391.009-725.851zm945.375 97.409 366.571 684.945h-733.142l366.571-684.945zm534.29 677.876V1731.762H745.993v1668.329H378.395V1648.865L1821.131 613.287l1448.563 1041.52v1745.284h-417.082z"
              />
            </svg>
            المخزن
          </router-link>

          <!-- الطلبات -->
          <router-link
            v-if="role.id == '13d34058-124e-4d83-8a5d-9127e9e6c2d7'"
            :to="{ name: 'cart_medical_supplies' }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/cart')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/cart')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              width="80"
              height="80"
              viewBox="0 0 80 80"
            >
              <path
                fill-rule="evenodd"
                d="M58.177 80H8.346A7.155 7.155 0 0 1 .99 73.083V6.916A7.155 7.155 0 0 1 8.346 0h49.831a7.155 7.155 0 0 1 7.358 6.916V18.15a1.991 1.991 0 0 1-3.982 0V6.916A3.176 3.176 0 0 0 58.177 4H8.346a3.174 3.174 0 0 0-3.374 2.916v66.167A3.174 3.174 0 0 0 8.346 76h49.831a2 2 0 1 1 0 4zM37.6 44.149h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 1 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm35.363-40h-7.488a2 2 0 1 1 0-4h7.488a2 2 0 0 1-.004 4h.004zm-17.443 0h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm17.92 8h-7.965a2 2 0 1 1 0-4H37.6a2 2 0 1 1 0 4zm-17.92 0h-7.964a2 2 0 1 1 0-4h7.964a2 2 0 0 1-.004 4h.004zm57.142 37.478c-.1 0-.352-.019-.449-.033-11.029-1.627-21.81-4.838-22.588-23.772h-8.443a2 2 0 0 1-1.567-3.234l14.958-19.151a1.988 1.988 0 0 1 3.135 0l14.956 19.151a2 2 0 0 1-1.567 3.234h-8.518c-.407 10.127 3.465 14.041 11.431 18.213a2.966 2.966 0 0 1-1.352 5.592h.004zM49.435 45.822h6.3a1.994 1.994 0 0 1 1.991 1.991c.061 14.4 5.633 18.774 13.6 20.765-6.156-4.357-9.345-10.038-8.439-20.922a1.992 1.992 0 0 1 1.983-1.834h6.3L60.3 31.912l-10.865 13.91z"
              />
            </svg>
            الطلبات
          </router-link>

          <!-- تسليم اللقاحات -->
          <router-link
            v-if="role.id == '13d34058-124e-4d83-8a5d-9127e9e6c2d7'"
            :to="{
              name: 'deliveryvaccinesMedicalSuppliesOrder',
              params: { id: role.guid },
            }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/delivery')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 fill-current"
              :class="
                this.checkRoutePath.includes('/delivery')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 64 64"
              viewBox="0 0 64 64"
            >
              <path
                d="M37.8 4.3c0-.6-.5-1-1-1h-5.9C30.1 1.3 28.2 0 26 0c-3 0-5.3 2.4-5.3 5.3h16.2C37.4 5.3 37.8 4.9 37.8 4.3zM30.1 10.3v-3h-8.4v2.2c0 2.2 1.8 4 4 4h1.2C28.7 13.5 30.1 12.1 30.1 10.3zM46.9 21.3c.2 0 .5.1.7.2l1.3 1.1V19H45v3.6l1.3-1.1C46.4 21.4 46.6 21.3 46.9 21.3zM24.3 15.4L24.2 17h2.4l.2-1.4h-1.2C25.2 15.6 24.8 15.5 24.3 15.4zM42.5 56.1c0 0-.1 0-.2 0l0 0h-.1l-3 .3c-.2 0-.4 0-.6 0-.4-.1-.8-.2-1.1-.5-.5-.4-.8-1-.9-1.6l-.5-5.5c-.1-.6-.2-1.1-.4-1.7-.1-.2-.2-.4-.3-.6L31.2 40l-1.7-2.7h-5.7c-.6 0-1-.5-1-1 0-.6.5-1 1-1h5.3v-6h-1.2c-.4 0-.8-.3-.9-.6-.1-.1-.1-.3-.1-.4 0-.6.5-1 1-1h2.2c.1 0 .3 0 .4.1l.1.1c.1 0 .1.1.2.1l3 2.9c.5.5 1.2.8 1.9.8h6.8c.3 0 .5-.1.7-.3l0 0c.1 0 .1-.1.1-.2.1-.2.2-.4.2-.6 0-.3-.1-.5-.3-.7s-.4-.3-.7-.3h-5.3c-1.4 0-2.8-.6-3.8-1.5l-.1-.1c-.1-.1-.1-.1-.2-.2-.1-.1-.2-.2-.3-.3L32.7 27c-.1-.2-.2-.3-.3-.5l-.3-.6L29 20c0 0 0-.1-.1-.1-.1-.1-.2-.2-.3-.3-.1-.1-.1-.1-.2-.2-.1 0-.1-.1-.2-.1-.1-.1-.2-.1-.3-.1-.1 0-.1-.1-.2-.1S27.5 19 27.4 19c-.1 0-.2 0-.3 0H27h-2.8c-.3 0-.5.1-.8.1-.2.1-.4.2-.5.3 0 0 0 0-.1.1-.2.1-.3.2-.4.4l0 0c-.1.1-.2.3-.3.4 0 .1-.1.1-.1.2-.1.1-.1.3-.1.4V21l-2 18.2L19 47.7c0 .4-.1.7-.2 1.1-.4 1.5-1.1 2.9-2.2 4.1l-2.5 2.5c-.1.1-.2.3-.2.5s.1.5.2.7l5.2 5.2c.2.2.6.3.9.2.1 0 .2-.1.3-.2.1-.1.1-.2.2-.3.1-.2.1-.4 0-.6 0-.1-.1-.2-.1-.3l-1-1.4L19.4 59l0 0c-.7-1-.7-2.2-.1-3.3 0 0 0-.1.1-.1l1.9-2.7c.1-.1.1-.2.2-.3s.1-.2.2-.3c.1-.2.2-.3.2-.5 0-.1.1-.1.1-.2.2-.4.3-.9.4-1.4l1.6-8.9c0-.2.2-.4.4-.6.1-.1.3-.2.4-.2s.1 0 .2 0h.1c.1 0 .3.1.4.1.1.1.3.2.4.3l.7 1 5.7 8.4c.6.9 1 1.9 1.1 3 0 .1 0 .2 0 .3l.6 5.6c0 .1 0 .1.1.1 0 0 0 0 0 .1l.1.1c.1 0 .2.1.3 0l2.4-.9 5.6-2.1c.1 0 .1-.1.2-.1 0-.1.1-.1.1-.2 0-.2-.1-.2-.1-.3C42.6 56.1 42.6 56.1 42.5 56.1z"
              />
              <path
                d="M55.2 19h-4.3v5.8c0 .4-.2.8-.6.9-.1.1-.3.1-.4.1-.2 0-.5-.1-.7-.2l-2.3-1.9-2.3 1.9c-.3.3-.7.3-1.1.1-.4-.2-.6-.5-.6-.9V19h-4.3c-1.1 0-2 .9-2 2v6c.2.1.5.1.7.1h5.3c.8 0 1.6.3 2.2.9s.9 1.3.9 2.2c0 .8-.3 1.6-.9 2.2-.1.1-.3.2-.4.3 0 0 0 0-.1.1S44.1 32.9 44 33c-.1 0-.1.1-.2.1-.1 0-.1 0-.2.1-.3.1-.6.2-1 .2h-5.8V35c.3.8 1 1.2 1.9 1.2h16.6c1.1 0 2-.9 2-2V21C57.2 19.9 56.3 19 55.2 19zM59.9 62H4.1c-.6 0-1 .5-1 1s.5 1 1 1H60c.6 0 1-.5 1-1S60.5 62 59.9 62z"
              />
            </svg>
            تسليم اللقاحات
          </router-link>

          <!-- التألف -->
          <router-link
            v-if="role.id == '13d34058-124e-4d83-8a5d-9127e9e6c2d7'"
            :to="{ name: 'SpoiledMedicalSupplies', params: { id: role.guid } }"
            class="group flex items-center px-2 py-2 text-sm font-medium rounded-md"
            :class="
              this.checkRoutePath.includes('/spoiled')
                ? 'bg-gray-800 dark:bg-gray-900 text-white '
                : 'text-gray-300 hover:bg-gray-700 hover:text-white '
            "
          >
            <svg
              class="mx-3 flex-shrink-0 h-6 w-6 stroke-2 stroke-current"
              :class="
                this.checkRoutePath.includes('/spoiled')
                  ? 'text-gray-300 '
                  : 'text-gray-400 group-hover:text-gray-300'
              "
              width="256"
              height="256"
              viewBox="0 0 256 256"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M96 72V48"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M160 208V184"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M72 96H48"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M208 160H184"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M71.0289 128.402L59.7151 139.716C52.2174 147.218 48.0062 157.391 48.0078 167.998C48.0094 178.605 52.2235 188.776 59.7235 196.276C67.2235 203.776 77.3953 207.99 88.0019 207.992C98.6085 207.994 108.781 203.782 116.284 196.285L127.597 184.971M184.97 127.598L196.284 116.285C203.781 108.782 207.993 98.6095 207.991 88.0028C207.989 77.3962 203.775 67.2245 196.275 59.7245C188.775 52.2245 178.604 48.0104 167.997 48.0088C157.39 48.0072 147.217 52.2183 139.715 59.7161L128.401 71.0298"
                stroke-width="16"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            التألف
          </router-link>
        </nav>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      role: this.$store.state.auth.role,
      menu: false,
      hamburger_menu: false,
      privilege: "",
      user_role: "",

      name: this.$store.state.auth,
    };
  },

  //   this.hamburger_menu = false
  computed: {
    checkRoutePath: function () {
      return this.$route.path;
    },
  },

  created() {
    console.log("this.name.role");
    console.log(this.name);
    console.log("this.name");
    this.user_role = localStorage.getItem("user_role");

    // let user = this.$store.state.auth.user

    // for (let index = 0; index < user.privileges.length; index++) {
    //     const element = user.privileges[index];

    //     let privilege = this.getPrivilegesKey(element)

    //     for (let i = 0; i < privilege.length; i++) {
    //         const element = privilege[i];
    //         this.privilege = element
    //     }
    // }
  },

  mounted() {
    if (
      localStorage.getItem("color-theme") === "dark" ||
      (!("color-theme" in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
    ) {
      document.documentElement.classList.add("dark");
      document
        .getElementById("theme-toggle-light-icon")
        .classList.remove("hidden");
    } else {
      document.documentElement.classList.remove("dark");
      document
        .getElementById("theme-toggle-dark-icon")
        .classList.remove("hidden");
    }
  },

  methods: {
    router_link(router) {
      console.log(router);
      this.hamburger_menu_toggle();
      this.$router.push(router);
    },

    getPrivilegesKey(key) {
      return Object.keys(key);
    },

    logout() {
      localStorage.removeItem("vuex");
      localStorage.removeItem("_secure__ls__metadata");
      this.$router.push({ name: "login" });
    },

    // async logout(e) {
    //   e.preventDefault();
    //   // const authUser = await this.$store.dispatch("auth/logout");
    // },

    theme_toggle() {
      document
        .getElementById("theme-toggle-dark-icon")
        .classList.toggle("hidden");
      document
        .getElementById("theme-toggle-light-icon")
        .classList.toggle("hidden");

      if (localStorage.getItem("color-theme")) {
        if (localStorage.getItem("color-theme") === "light") {
          document.documentElement.classList.add("dark");
          localStorage.setItem("color-theme", "dark");
        } else {
          document.documentElement.classList.remove("dark");
          localStorage.setItem("color-theme", "light");
        }
      } else {
        if (document.documentElement.classList.contains("dark")) {
          document.documentElement.classList.remove("dark");
          localStorage.setItem("color-theme", "light");
        } else {
          document.documentElement.classList.add("dark");
          localStorage.setItem("color-theme", "dark");
        }
      }
    },

    theme_menu(place) {
      if (place == "in") {
        this.menu = !this.menu;
      } else {
        this.menu = false;
      }
    },

    hamburger_menu_toggle() {
      this.hamburger_menu = !this.hamburger_menu;
    },
  },
};
</script>

<style></style>
